import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Callout, Icon, toast } from '@node-space/ui-components'
import { SidePanelSection, SidePanelSectionProps } from 'components/SidePanel/SidePanelSection'
import { copyToClipboard } from 'utils/utils'

export interface CTASectionProps extends SidePanelSectionProps {
  ctaLabel: string
  ctaLink: string
  isCopyAction?: boolean
  isPendingStatus?: boolean
  helpText?: string
}

export const CTASection = ({
  heading,
  ctaLabel,
  ctaLink,
  isCopyAction,
  isPendingStatus,
  helpText,
}: CTASectionProps) => {
  const { t } = useTranslation()

  const onCopy = () => {
    copyToClipboard(ctaLink)
    toast({ header: t('copiedToClipboard'), variant: 'success' })
  }

  const onNavigate = () => {
    window.open(ctaLink)
  }

  return (
    <SidePanelSection heading={heading}>
      <Callout
        {...(isPendingStatus && { variant: 'warning' })}
        GhostButton={
          <Button
            iconElement={<Icon name={isCopyAction ? 'Copy' : 'ArrowSquareOut'} />}
            onClick={isCopyAction ? onCopy : onNavigate}
          >
            {ctaLabel}
          </Button>
        }
      >
        {helpText}
      </Callout>
    </SidePanelSection>
  )
}
